var map = {
	"./about/About.vue": [
		610,
		15
	],
	"./archive/Archive.vue": [
		611,
		24
	],
	"./archiveWinners/ArchiveWinners.vue": [
		612,
		25
	],
	"./docs/Docs.vue": [
		613,
		32
	],
	"./home/Home.vue": [
		614,
		10
	],
	"./live/Live.vue": [
		615,
		26
	],
	"./members/Members.vue": [
		616,
		17
	],
	"./news/News.vue": [
		617,
		3
	],
	"./notFound/NotFound.vue": [
		618,
		36
	],
	"./partners/Partners.vue": [
		619,
		33
	],
	"./votes/Votes.vue": [
		620,
		7
	],
	"./votesForm/VotesForm.vue": [
		621,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 595;


//////////////////
// WEBPACK FOOTER
// ./src/app2025/pages lazy ^\.\/.*\.vue$
// module id = 595
// module chunks = 41